import { useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import "../login/styles.css";
import { useTranslation } from "react-i18next";
import axios from "axios";

const ForgotPassword = () => {
  const { t } = useTranslation();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const active_lang = localStorage.getItem("i18lang");

  const SendData = async (data: string) => {
    const resetToken = localStorage.getItem("resetToken");
    const sendData = JSON.stringify({
      newPassword: password,
      resetToken: resetToken,
    });

    const res = await axios.post(
      "http://api.udrc.uz/api/users/reset_password",
      sendData,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    if (res.status === 201) {
      navigate("/login");
      localStorage.removeItem("resetToken")
      localStorage.removeItem("email")
    } else {
    }
  };

  return (
    <div className="login_page bg-main_color min-h-screen text-white w-full lg:px-20 sm:px-10 px-5">
      <div className="max-w-[1681px] mx-auto">
        <div className="flex items-center h-screen justify-center">
          <div className="w-[500px] max-sm:w-full px-5">
            <h2 className="text-[40px] mb-3 font-bold">Enter new password!</h2>
            <form
              onSubmit={(e) => {
                e.preventDefault();
                SendData(email);
              }}
              className="w-full"
            >
              <input
                required
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="new password"
                className="w-full mb-4 rounded-md h-[40px] py-2 px-3 focus:border-none outline-none text-[#29487E]"
              />
              <button
                type="submit"
                className="w-full bg-main_color border h-[40px] text-[20px] py-0 border-solid border-white text-white font-bold rounded mb-4"
              >
                Change password
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
